<template>
  <el-col :span="24" class="content">
    <vue-particles 
      class="vue-particles" 
      color="#77EFFF" 
      :particleOpacity="0.8" 
      :particlesNumber="100" 
      shapeType="circle" 
      :particleSize="3" 
      linesColor="#77EFFF" 
      :linesWidth="2" 
      :lineLinked="true" 
      :lineOpacity="0.4" 
      :linesDistance="110" 
      :moveSpeed="1.8" 
      :hoverEffect="true" 
      hoverMode="grab" 
      :clickEffect="true" 
      clickMode="push">
    </vue-particles>
    <div style="margin-top: 15px;" id="search-box">
      <div>
        <el-input placeholder="请输入技术关键词、公开号、申请人、专利权人等" v-model="params.keyword">
            <el-button slot="prepend" @click="showDialog = true">
              <i class="el-icon-full-screen"></i>
            </el-button>
        </el-input>
        <el-button type="primary" icon="el-icon-search" @click="searchJudge" class="el-button--primary-add">搜索</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="showDialog" title="范围设定">
      <p style="font-weight: bold">专利类型</p>
      <el-checkbox-group v-model="params.patent_type">
        <el-checkbox v-for="(item, index) in patent_type" :label="item.value" :key="index">{{item.name}}</el-checkbox>
      </el-checkbox-group>
      <p style="font-weight: bold">数据范围</p>
      <el-radio-group v-model="params.range_type" @input="changeRadio">
        <el-radio :label="0">全球</el-radio>
        <el-radio :label="1">国内</el-radio>
        <el-radio :label="2">国外</el-radio>
      </el-radio-group>
      <div style="margin:20px 0">
        <el-checkbox-group v-model="params.range">
          <el-checkbox v-for="(item, index) in country_data" :label="item.id" :key="index">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <template #footer>
        <el-button @click="reset()">重置</el-button>
        <el-button type="primary" @click="showDialog = false">保存</el-button>
      </template>
    </el-dialog>
  </el-col>
</template>

<script>
  import { country } from "@/api/patent.js";
  export default {
    name: 'home',
    data() {
      return {
        user:{},
        showDialog:false,
        patent_type:[
          {
            name:'发明专利',
            value:1
          },
          {
            name:'实用新型',
            value:2
          },
          {
            name:'外观设计',
            value:3
          }
        ],
        country_data:[],
        params: {
          keyword: '',
          patent_type: [1,2,3],
          range_type: 0,
          range: []
        }
      }
    },
    mounted() {
      this.getCountry()
      let user=sessionStorage.getItem('user');
      if(user){
        this.user=JSON.parse(user);
      }
    },
    methods: {
      async getCountry(){
        let res=await country();
        if(res.errno == 0){
          this.country_data=res.data;
          this.params.range=[]
          for(var i in this.country_data){
            this.params.range.push(this.country_data[i].id)
          }
        }else{
          this.$message.error(res.errmsg);
        }
      },
      reset(){
        this.params.patent_type=[1,2,3];
        this.params.range_type=0;
        this.params.range=[]
        for(var i in this.country_data){
          this.params.range.push(this.country_data[i].id)
        }
      },
      searchJudge() {
        if(!this.user.username){
          this.$message.error('您当前还没有登录，请登录账户');
          return;
        }
        if(this.params.keyword == "") {
          this.$message.error('请输入搜索内容');
        }else {
          sessionStorage.setItem("params",JSON.stringify(this.params));
          this.$router.push({name:'result'});
        }
      },
      changeRadio(e){
        this.params.range=[]
        if(e==0){
          for(var i in this.country_data){
            this.params.range.push(this.country_data[i].id)
          }
        }else if(e==1){
          for(var i in this.country_data){
            if(this.country_data[i].type==1){
              this.params.range.push(this.country_data[i].id)
            }
          }
        }else{
          for(var i in this.country_data){
            if(this.country_data[i].type==2){
              this.params.range.push(this.country_data[i].id)
            }
          }
        }
      }
    }
  }

</script>

<style scoped>
  :deep(.el-dialog__body){
    padding: 10px 20px;
  }
  
  #particles-js {
    height: 100%;
    width: 100%;
  }
  .content {
    display: flex;
    height: calc(100vh - 208px);
    background: url("~@/assets/earth.jpg") no-repeat;
    overflow: hidden;
    background-size:cover;
  }
  #search-box {
    position: absolute;
    width: 50%;
    left: 25%;
    top: 20%;
  }
  .el-input {
    width: calc(100% - 142px);
    margin-right: 24px;
    font-size: 16px;
  }
  .el-select {
    width: 128px;
  }
  .el-select-dropdown__item.selected {
    color: #1287C9;
  }
  ::v-deep .el-input__inner{
    height: 56px;
  }
  
  .el-button--primary-add  {
    height: 56px;
    font-size: 16px !important;
    padding: 0px 32px 0px 32px;
  }

  #image-upload {
    background-color: rgb(255,255,255,0.6);
    display: block;
    margin-top: 24px;
    border: 1px dashed #5795B8;
    border-radius: 8px;
    padding: 8px 0 24px 32px;
  }

  #image-upload p {
    font-size: 14px;
    color: #1D2129;
  }

  .block {
    margin-bottom: 16px;
  }
</style>
